import React from 'react';
import { ListGroup } from 'react-bootstrap';
import { Tooltip, Typography, styled, tooltipClasses } from '@mui/material';

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));

const LinkedIssuesTooltip = ({ linkedIssues, totalIssues }) => {
  const getPriorityData = () => {
    return linkedIssues.reduce((acc, issue) => {
      const priority = issue?.priority;
      if (priority) {
        if (acc[priority]) {
          acc[priority].count += issue.count || 0;
        } else {
          acc[priority] = {
            count: issue.count || 0,
            name: priority,
          };
        }
      }
      return acc;
    }, {});
  };

  const priorityData = getPriorityData();

  const renderTooltip = () => (
    <HtmlTooltip
      id="linked-issues-tooltip"
      title={
        <ListGroup variant="flush">
          <ListGroup.Item style={{ whiteSpace: 'nowrap' }}>
            <strong>Issues by Priority</strong>
          </ListGroup.Item>
          {Object.keys(priorityData).length === 0 ? (
            <ListGroup.Item>No issues linked</ListGroup.Item>
          ) : (
            Object.keys(priorityData).map((priority, index) => (
              <ListGroup.Item key={`priority-${index}`}>
                {priority}: {priorityData[priority].count || 0}
              </ListGroup.Item>
            ))
          )}
        </ListGroup>
      }>
      <Typography
        variant="body1"
        sx={{
          fontWeight: 'bold',
          color: 'var(--primary-color)',
          display: 'inline-flex',
          alignItems: 'center',
          '&:hover': {
            textDecoration: 'underline',
            cursor: 'pointer',
          },
        }}>
        {totalIssues}
      </Typography>
    </HtmlTooltip>
  );

  return <>{renderTooltip()}</>;
};

export default LinkedIssuesTooltip;
